import Vue from 'vue'
import Router from 'vue-router'
import Login from '../view/Login'
import Main from '../view/Main'
import Index from '../view/Index'
import Operaview from '../view/Operaview'
import Upload from '../view/Upload'
import Uploadlist from "../view/Uploadlist";
import Install from '../view/Install'
import Out from '../view/Out'
import Aindex from '../view/admin/Index'
import Alogin from '../view/admin/Login'
import Amain from '../view/admin/Main'
import Ainstall from  '../view/admin/Install'
import Arole from  '../view/admin/Role'
import Amenus from '../view/admin/Menus'
import Ausers from "../view/admin/Users"
import Amanager from "../view/admin/Manager"
import Aoperator from "../view/admin/Operator"
import Ascore from "../view/admin/Score"
import Ascoretype from "../view/admin/Scoretype"
import Asetgps from "../view/admin/Setgps"
import Ainspection from "../view/admin/Inspection"
import Ascorefile from "../view/admin/Scorefile"
import Agrade from "../view/admin/Grade"
import Ascorelist from "../view/admin/Scorelist";
import Auditlaw from "../view/admin/Auditlaw";
import Auditplat from "../view/admin/Auditplat";
import Audittraffic from "../view/admin/Audittraffic";
import Ashowscore from "../view/admin/Showscore";
import Acycle from "../view/admin/Cycle";
import Cycle from "../view/Cycle";
import Asatisfac from "../view/admin/Satisfac";
import Gaode from "../view/admin/gaode";
import Chaotou_list from "../view/admin/chaotou_list";
import Choucha_list from "../view/admin/choucha_list";
Vue.use(Router)

export default new Router({
  //mode:'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      hidden:true
    },
    {
      path: '/main',
      name: 'Main',
      component: Main,
      children:[
      {
        path: '/index',
        name: 'Index',
        component: Index,
        props:true,
        meta:{id:1}
      },
      {
          path: '/Operaview',
          name: 'Operaview',
          component: Operaview,
          props:true,
          meta:{id:2}
      },
        {
          path: '/upload',
          name: 'Upload',
          component: Upload,
          props:true,
          meta:{id:3}
        },
        {
          path: '/uploadlist/:year/:quarter',
          name: 'Uploadlist',
          component: Uploadlist,
          props:true,
          meta:{id:4}
        },
      {
        path: '/cycle',
        name: 'Cycle',
        component: Cycle,
        props:true,
        meta:{id:5}
      },
      {
        path: '/install',
        name: 'Install',
        component: Install,
        props:true,
        meta:{id:4}
      },
        {
          path: '/out',
          name: 'Out',
          component: Out,
          props:true,
          meta:{id:2}
        },
      ]
    },
    {
      path: '/admin',
      name: 'Alogin',
      component: Alogin,
      hidden:true
    },

    {
      path: '/admin/main',
      name: 'Amain',
      component: Amain,
      children:[
        {
          path: '/admin/index',
          name: 'Aindex',
          component: Aindex,
          props:true,
          meta:{id:1}
        },
        {
          path: '/admin/auditlaw',
          name:'Auditlaw',
          component: Auditlaw,
          props: true,
          meta:{id:15}
        },
        {
          path: '/admin/auditplat',
          name:'Auditplat',
          component: Auditplat,
          props: true,
          meta:{id:14}
        },
        {
          path: '/admin/showscore/:cid/:curId/:typeid',
          name:'Ashowscore',
          component: Ashowscore,
          props: true,
          meta:{id:3}
        },
        {
          path: '/admin/audittraffic',
          name:'Audittraffic',
          component: Audittraffic,
          props: true,
          meta:{id:16}
        },

        {
          path: '/admin/scorelist',
          name:'Ascorelist',
          component: Ascorelist,
          props: true,
          meta:{id:3}
        },
        {
          path: '/admin/grade',
          name:'Agrade',
          component: Agrade,
          props: true,
          meta:{id:2}
        },
        {
          path: '/admin/scorefile',
          name:'Ascorefile',
          component: Ascorefile,
          props: true,
          meta:{id:24}
        },

        {
          path: '/admin/cycle',
          name:'Acycle',
          component: Acycle,
          props: true,
          meta:{id:28}
        },
        {
          path: '/admin/inspection',
          name:'Ainspection',
          component: Ainspection,
          props: true,
          meta:{id:6}
        },
        {
          path: '/admin/setgps',
          name:'Asetgps',
          component: Asetgps,
          props: true,
          meta:{id:23}
        },
        {
          path: '/admin/scoretype',
          name:'Ascoretype',
          component: Ascoretype,
          props: true,
          meta:{id:7}
        },
        {
          path: '/admin/score',
          name:'Ascore',
          component: Ascore,
          props: true,
          meta:{id:8}
        },
        {
          path: '/admin/operator',
          name:'Aoperator',
          component: Aoperator,
          props: true,
          meta:{id:9}
        },
        {
          path: '/admin/manager',
          name:'Amanager',
          component: Amanager,
          props: true,
          meta:{id:10}
        },
        {
          path: '/admin/users',
          name:'Ausers',
          component: Ausers,
          props: true,
          meta:{id:20}
        },
        {
          path: '/admin/menus',
          name:'Amenus',
          component: Amenus,
          props: true,
          meta:{id:11}
        },
        {
          path: '/admin/Role',
          name: 'Arole',
          component: Arole,
          props:true,
          meta:{id:12}

        },
        {
          path: '/admin/Install',
          name: 'Ainstall',
          component: Ainstall,
          props:true,
          meta:{id:13}
        },
        {
          path: '/admin/Satisfac',
          name: 'Asatisfac',
          component: Asatisfac,
          props:true,
          meta:{id:33}
        },
        {
          path: '/admin/gaode',
          name: 'Gaode',
          component: Gaode,
          props:true,
          meta:{id:34}
        },
		{
		  path: '/admin/chaotou_list',
		  name: 'Chaotou_list',
		  component: Chaotou_list,
		  props:true,
		  meta:{id:35}
		},
		{
		  path: '/admin/choucha_list',
		  name: 'choucha_list',
		  component: Choucha_list,
		  props:true,
		  meta:{id:36}
		}

      ]
    },


  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js